const promotionGetters = {
  getSalesPromotions: (state) => state.salesPromotions,
  getPromoFilters: (state) => state.promoFilters
}

export { promotionGetters }
